<!-- src/components/StatCard.vue -->
<template>
    <div class="col-6 col-md-3 d-flex justify-content-center text-center stat-card mb-3">
        <div class="d-flex justify-content-center align-items-center flex-column bg-primary text-light">
            <i :class="['fa', icon, 'stat-icon']"></i>
            <h3>{{ value }}</h3>
            <p>{{ label }}</p>
        </div>
    </div>
</template>
  
<script>  
    export default {
        name: "StatCard",
        props: {
            icon: {
                type: String,
                required: true,
            },
            value: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style scoped>
.stat-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    cursor: pointer;
}
.stat-card div {
    width: 150px;
    height: 150px;
    border-radius: 50%;
}
.stat-card div:hover {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
.stat-card i {
    font-size: 2rem;
}
</style>